<template>
    
</template>

<script>
import axios from 'axios';
import trans from '../mixins/trans';

export default {
    mixins: [
        trans
    ],

    data() {
        return {
            basketLoaded: false,
            total: null,
            items: []
        };
    },

    computed: {
        hasItems() {
            return Object.entries(this.items).length > 0;
        }
    },

    methods: {
        update() {
            axios.get('/api/warenkorb')
                .then(({data}) => {
                    this.basketLoaded = true;
                    this.total = data.total;
                    this.items = data.items;
                })
        },

        updateIfNotLoaded() {
            if(this.basketLoaded === false) {
                this.update();
            }
        },

        getItemPrice(item) {
            const total = parseFloat(item.subtotal) + parseFloat(item.tax);
            return total.toFixed(2).replace('.', ',');
        }
    }
}
</script>